import { gql } from 'graphql-tag';
import { COLLECTION_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/collection';
import { CONTENT_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/content';
export const SEARCH_RESULTS_GET = gql `
  ${COLLECTION_SHALLOW_FRAGMENT}
  ${CONTENT_SHALLOW_FRAGMENT}
  query allSearchResults(
    $query: String!,
    $page: Int!,
    $perPage: Int!,
  ) {
    Search(
      query: $query,
      page: $page,
      perPage: $perPage,
    ) {
      __typename
      id
      page
      nextPage
      prevPage
      pageCount
      perPage
      count
      results {
        id
        score
        item {
          ... on Content {
            ...ContentShallowFragment
          }
          ... on Collection {
            ...CollectionShallowFragment
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=search.js.map